import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import confirm from '../../utils/confirm';
import SaveDialog from './SaveDialog';
import Dialog from '../../toolkit/dialog';
import Content from '../dashboard/Content';
import Logger from '../../toolkit/logger/Logger';
import groupService from '../../services/group-service';
import SensorDialog from './SensorDialog';
import UploadPictureDialog from './UploadPictureDialog';
import ChooseTemplateDialog from '../template/ChooseTemplateDialog';
import { Group, Sensor } from '../interfaces';
import { getCurrentUser } from '../../utils/auth';
import { NodeItem, FloatNodeItem } from './NodeItem';

import './ManageGroups.scss';

interface ManageGroupsProps {
  match: {
    params: {
      groupId?: string
    }
  }
}

interface ManageGroupsState {
  groups: Group[],
  sensors: Sensor[],
  access: string[],
  redirect: string;
}

export default class ManageGroups extends React.Component<ManageGroupsProps, ManageGroupsState> {

  private nodeContainerRef = React.createRef<HTMLDivElement>();

  state = {
    groups: [] as Group[],
    sensors: [] as Sensor[],
    access: [],
    redirect: null
  }


  render() {
    const { redirect } = this.state;
    const addresses = this.getAddressBar();
    const angle = <i className="far fa-angle-left"></i>;
    let index = 0;

    if (redirect) {
      return <Redirect to={redirect} push />;
    }

    return (
    <Content title="خانه / نمایش گروه بندی">
        <div className="manage-groups-component h-100">
          <ul className="topbar">
            <li>
              <Link to="/dashboard/groups">ریشه {addresses.length > 0 ? angle : ''}</Link>
            </li>
            {addresses.map((g: any) => (
              <li key={g._id}>
                <Link to={g._id}>
                  {g.name}
                  {addresses.length === ++index ? '' : angle}
                </Link>
              </li>
            ))}
          </ul>
          <div className="toolbar">
            <div className="toolbar-group justify-content-end">
              <div className="toolbar-item">
                <Link className="btn btn-info" to={this.getEditLink()}>
                  <i className="far fa-edit"></i>
                  <span className="item-name">ویرایش</span>
                </Link>
              </div>
              <div className="toolbar-item">
                <button
                  {...this.attrMediaDisabled()}
                  className="btn btn-info"
                  onClick={this.handleApplyTemplate}>
                  <i className="far fa-cogs"></i>
                  <span className="item-name">تنظیمات گروهی</span>
                </button>
              </div>
              <div className="toolbar-item">
                <button
                  {...this.attrRemoveMediaDisabled()}
                  className="btn btn-primary"
                  onClick={this.handleSavePoints}>
                  <i className="far fa-save"></i>
                  <span className="item-name">ذخیره نقاط</span>
                </button>
              </div>
              <div className="toolbar-item">
                <button
                  {...this.attrRemoveMediaDisabled()}
                  className="btn btn-danger"
                  onClick={this.handleRemovePicture}>
                  <i className="far fa-trash-alt"></i>
                  <span className="item-name">حذف تصویر</span>
                </button>
              </div>
              <div className="toolbar-item">
                <button
                  {...this.attrMediaDisabled()}
                  className="btn btn-success"
                  onClick={this.handleUploadPicture}>
                  <i className="far fa-image"></i>
                  <span className="item-name">بارگذاری تصویر</span>
                </button>
              </div>
            </div>
          </div>
          {this.renderStructures()}
        </div>
      </Content>
    );
  }

  renderStructures = () => {
    const { groups, sensors } = this.state;
    const groupId = this.getGroupId();
    const current = groups.find(g => g._id === groupId);
    const hasBackground = current && current.media && current.media.link;
    const style = hasBackground ? { backgroundImage: `url("${current.media.link}")` } : { backgroundImage: 'none' };

    let filteredGroups: Group[];
    let filteredSensors: Sensor[];

    if (groupId) {
      filteredGroups = groups.filter(g => g.parent === groupId);
      filteredSensors = sensors.filter(s => {
        if (s.group == null) return false;
        return s.group._id as any === groupId;
      });
    }
    else {
      filteredGroups = groups.filter(g => g.parent === null);
      filteredSensors = sensors.filter(s => s.group === null);
    }

    if (hasBackground) {
      Logger.info('ManageGroup::NodeContainer::Float');
      return (
        <div className="node-container" style={style} ref={this.nodeContainerRef}>
          {this.renderFloat(filteredGroups, filteredSensors)}
        </div>
      );
    }

    Logger.info('ManageGroup::NodeContainer::Normal');
    return (
      <div className="node-container" style={style} ref={this.nodeContainerRef}>
        {this.renderNormalGroups(filteredGroups)}
        {this.renderNormalSensors(filteredSensors)}
      </div>
    );

  }

  renderNormalGroups = (groups: any[]) => {
    return (
      <React.Fragment>
        {groups.map(group => (
          <NodeItem
            id={group._id}
            key={group._id}
            name={group.name}
            type='group'
          />
        ))}
      </React.Fragment>
    );
  };

  renderNormalSensors = (sensors: any[]) => {
    return (
      <React.Fragment>
        {sensors.map(sensor => (
          <NodeItem
            id={sensor._id}
            key={sensor._id}
            name={sensor.name}
            sensor={sensor}
            type='sensor'
            onClick={this.handleSensorClick}
          />
        ))}
      </React.Fragment>
    );
  };

  renderFloat = (groups: any[], sensors: any[]) => {
    const noPrefCondidtion = x => !x.prefs || !x.prefs.picturePoint || (typeof x.prefs.picturePoint.left != 'number');
    const noPrefGroups = [];
    const noPrefSensors = [];

    const prefGroups = [];
    const prefSensors = [];

    for (const group of groups) {
      if (noPrefCondidtion(group)) {
        noPrefGroups.push(group);
      }
      else {
        prefGroups.push(group);
      }
    }

    for (const sensor of sensors) {
      if (noPrefCondidtion(sensor)) {
        noPrefSensors.push(sensor);
      }
      else {
        prefSensors.push(sensor);
      }
    }

    const content1 = this.renderNoPrefItems([...noPrefGroups, ...noPrefSensors]);
    const content2 = this.renderPrefItems([...prefGroups, ...prefSensors]);

    return (
      <React.Fragment>
        {content1}
        {content2}
      </React.Fragment>
    );
  }

  renderPrefItems = (prefItems: any[]) => {
    const items = [];
    for (const item of prefItems) {
      const isSensor = item.group;
      const { left, top } = item.prefs.picturePoint;
      items.push(
        <FloatNodeItem
          id={item._id}
          key={item._id}
          name={item._id}
          top={top + '%'}
          left={left + '%'}
          type={isSensor ? 'sensor' : 'group'}
          wrapperElement={this.nodeContainerRef.current}
        />
      )
    }
    return items;
  }

  renderNoPrefItems = (noPrefItems: any[]) => {
    Logger.info('ManageGroup::RenderFlaot::NoPref called');
    const noPrefCount = noPrefItems.length;
    const percent = Number((100 / noPrefCount).toPrecision(6));
    const items = [];
    for (let i = 0; i < noPrefCount; i++) {
      const left = (i * percent) + '%';
      const item = noPrefItems[i];
      const isSensor = item.group;
      Logger.info(`ManageGroup::renderNoPrefItems[${i}] left=${left} with type`, item);

      items.push(
        <FloatNodeItem
          id={item._id}
          key={item._id}
          name={item._id}
          top="20%"
          left={left}
          type={isSensor ? 'sensor' : 'group'}
          containerWidth={percent + '%'}
          wrapperElement={this.nodeContainerRef.current}
        />
      );
    }
    return items;
  }

  attrMediaDisabled = () => {
    const groupId = this.getGroupId();
    if (groupId == null) {
      return { disabled: true };
    }
    return {};
  }

  attrRemoveMediaDisabled = () => {
    const current = this.getCurrentGroup();

    if (current == null || !current.media || !current.media.link) {
      return { disabled: true };
    }
    return {};
  }

  getGroupId = () => {
    return this.props.match.params.groupId;
  }

  getCurrentGroup = () => {
    const groupId = this.getGroupId();
    return this.state.groups.find(g => g._id === groupId);
  }

  getAddressBar = () => {
    const groups = this.state.groups;
    const groupId = this.getGroupId();
    let result = [] as any[];
    let current = groups.find(g => g._id === groupId);
    if (!current) {
      return result;
    }
    result.push(current);
    while (current?.parent != null) {
      // eslint-disable-next-line
      const founded = groups.find(g => g._id === current?.parent);
      result.push(founded);
      current = founded;
    }
    return result.reverse();
  }

  getEditLink = () => {
    let id = this.getGroupId();
    const urlId = id ? ('/' + id) : '';
    const query = '?back=' + (id ?? '');
    return '/dashboard/edit-groups' + urlId + query;
  }

  async componentDidMount() {
    try {
      const user = getCurrentUser();
      const data = await groupService.fetchData(user._id, user.parent ? user.parent : user._id);
      const { groups, sensors } = data;
      this.setState({ groups, sensors });
    }
    catch (e) {
      console.error(e);
    }
  }

  handleSensorClick = (id: string) => {
    const dialog = new Dialog({
      rtl: true,
      size: 'small',
      showTitle: false,
      message: SensorDialog,
      onResolve: path => {
        this.setState({ redirect: path });
        dialog.close();
      }

    });
    dialog.show({ id });
  }

  handleUploadPicture = () => {
    const dialog = new Dialog({
      rtl: true,
      size: 'small',
      title: 'تصویر مورد نظر را از طریق باکس پایین آپلود کنید.',
      message: UploadPictureDialog,
      onClose: () => this.componentDidMount()
    });
    dialog.show({ groupId: this.getGroupId() });
  }

  handleApplyTemplate = () => {
    const group = this.getCurrentGroup();
    const dialog = new Dialog({
      rtl: true,
      size: 'small',
      showTitle: false,
      message: ChooseTemplateDialog,
      onResolve: async ({ templateId, fields, recursive }) => {
        try {
          await groupService.applyTemplate(group._id, {
            fields,
            recursive,
            templateId
          });
          confirm({
            type: 'success',
            size: 'small',
            title: 'الگو با موفقیت بر روی گروه مورد نظر اعمال شد.',
            primaryClass: 'd-none',
            cancelText: 'باشه',
            onSubmit: () => { }
          }).show()
        }
        catch (e) {
          console.error(e);
        }
      }
    });
    dialog.show({ group });
  }

  handleSavePoints = async () => {

    const items = document.getElementsByClassName('float-node-item');
    const data = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i] as HTMLElement;
      const id = item.getAttribute('data-id');
      Logger.warning('WWWW', id);
      const type = item.getAttribute('data-type');
      const top = Number(item.style.top.replace('%', '')).toPrecision(6);
      const left = Number(item.style.left.replace('%', '')).toPrecision(6);
      data.push({ id, type, top, left });
    }
    const dialog = new Dialog({
      rtl: true,
      size: 'small',
      title: 'در حال ذخیره سازی اطلاعات',
      message: SaveDialog,
      onClose: () => {
        this.componentDidMount();
      }
    });
    dialog.show({ data });
  }

  handleRemovePicture = () => {
    const dialog = confirm({
      title: 'آیا میخواهید تصویر زمینه را حذف کنید؟',
      type: 'alert',
      size: 'small',
      primaryClass: 'ant-btn ant-btn-danger',
      onSubmit: async () => {
        try {
          await groupService.removeMedia(this.getGroupId());
          this.componentDidMount();
        }
        catch (e) {
          console.error(e);
        }
      }
    });
    dialog.show();
  }

}
